import { Component } from '@angular/core';
import { faDownload, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { StatementService } from 'src/app/pages/privado/services/previdencia/statement.service';
@Component({
  selector: 'app-historico-declaracao-ppe',
  templateUrl: './historico-declaracao-ppe.component.html',
  styleUrls: ['./historico-declaracao-ppe.component.css']
})
export class HistoricoDeclaracaoPPEComponent {
  //icones
  faDownload = faDownload
  faFileDownload = faFileDownload;
  loadingCosts: boolean = false;
  statementHistory: any;
  itemsPerPage: number = 5;
  Page: number = 1;
  //VARIÁVEIS PAGINAÇÃO
  tamanhoLista: number = 0;
  filter: any = { ItemsPerPage: 5, Page: 0, IsPaginated: true };
  constructor(private statementService: StatementService) {
    this.getFilter(this.filter);
  }
  onChangeQuantidadeItens(quantidade: number) {
    this.filter.ItemsPerPage = quantidade;
    this.filter.Page = 0;
    this.getFilter(this.filter);
  }
  onChangePagination(page: number) {
    this.filter.Page = page;
    this.getFilter(this.filter);
  }
  getFilter(dataFilter: any) {
    this.statementService.getStatementPaginated(dataFilter).subscribe({
      next: (res: any) => {
        this.statementHistory = res;
        this.tamanhoLista - res.totalItems;
      }
    });
  }
  download(code: any) {
    this.statementService.getStatementPdf(code).subscribe({
      next: (data) => {
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = "Declaracao_de_Pessoa_Politicamente_Exposta.pdf";
        a.href = URL.createObjectURL(data);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
      }
    });
  }
}
